import React from 'react';

export interface IMultipleUserInputProps {
    children: React.ReactNode;
}

export function MultipleUserInput({
    children,
}: IMultipleUserInputProps): JSX.Element {
    // 12px, the same gap the stack uses vertically. At 24px the gutter
    // between two fields was wider than the space above them, so a row
    // read as two separate things rather than one pair.
    // Top-aligned.
    //
    // items-end lined the controls up when one label wrapped, but it aligned
    // the columns by their bottoms — so the moment one field showed a
    // validation message, the field beside it was pushed down by the height
    // of that message.
    //
    // A two-line floor on the labels was the first attempt at keeping the
    // wrap case level, and it cost every row the height of a second line
    // whether it needed one or not. Single-line labels are the common case,
    // so the floor is gone: a wrapping label can still drop its own control
    // by a line, but nothing steals space from the rows that do not wrap.
    return (
        <div className='_flex items-start space-x-3'>
            {children}
        </div>
    );
}
